/* ah-lead-capture — WhatsApp-first lead capture for abanahomes.com (Dawn-AH).
 * One full popup per session at most; after a dismissal the popup rests 7 days and a small credit pill stays.
 * Never shown to logged-in customers or to someone who already gave their number on this browser.
 * Preview: ?ahlc=force (show now) · ?ahlc=reset (forget this browser) · ?ahlc=quiz (force the quiz) */
(function () {
  'use strict';
  var C = window.AHLC;
  if (!C || window.__ahlcLoaded) return;
  window.__ahlcLoaded = true;

  var P = C.page || {};
  var LS = safeStore(window.localStorage), SS = safeStore(window.sessionStorage);
  var qs = new URLSearchParams(location.search);
  var mode = qs.get('ahlc');
  if (mode === 'reset') ['ahlc_known', 'ahlc_rest_until', 'ahlc_vid', 'ahlc_pill_off', 'ahlc_cart_saved'].forEach(function (k) { LS.del(k); });
  var forced = mode === 'force' || mode === 'quiz';

  // Never interrupt a purchase: once the visitor taps Buy now / Book / Add to cart / Checkout, no popup or pill
  // for the rest of the session, and nothing auto-opens while a checkout or payment window is on screen.
  var BUY_SEL = '.ah-checkout-buynow, .ah-checkout-launch__button, [onclick*="AHCheckout"], [name="add"], [name="checkout"], ' +
    '.shopify-payment-button, .gokwik-checkout, #gokwik-buy-now, [onclick*="gokwik"]';
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(BUY_SEL) && !e.target.closest('.ahlc-overlay, .ahlc-pill, .ahlc-cartbar')) {
      SS.set('ahlc_buying', '1'); closeQuiet(); removePill();
    }
  }, true);
  function buying() { return SS.get('ahlc_buying') === '1'; }
  // Real windows only — Dawn keeps closed modals (search, menu) in the DOM as tiny/zero-size boxes.
  function shown(n) {
    if (!n || n.hidden || getComputedStyle(n).visibility === 'hidden') return false;
    var r = n.getBoundingClientRect();
    return r.width > 200 && r.height > 200;
  }
  function checkoutOpen() {
    if (shown(document.getElementById('ah-checkout-overlay'))) return true;
    var n = document.querySelectorAll('.razorpay-container, iframe[src*="razorpay"], iframe[src*="gokwik"], cart-drawer.active, [aria-modal="true"]');
    for (var i = 0; i < n.length; i++) if (!n[i].closest('.ahlc-overlay') && shown(n[i])) return true;
    return false;
  }
  var RUPEE = '₹';
  var CREDIT = RUPEE + C.credit, MIN = RUPEE + Number(C.minOrder).toLocaleString('en-IN');
  var CONSENT = 'I agree to get offers & plant-care tips from Abana Homes on WhatsApp. Reply STOP anytime.';
  // Declared up here: the init code below returns early, so vars assigned further down would stay undefined.
  var QUIZ = [
    { q: 'Where will your bonsai live?', a: [['low', 'Indoors, away from the window'], ['window', 'Indoors, near a bright window'], ['out', 'Balcony or outdoors']] },
    { q: 'Is this your first bonsai?', a: [['first', 'Yes, my first one'], ['exp', 'I’ve kept plants before']] },
    { q: 'What’s your budget?', a: [['b1', 'Under ' + RUPEE + '1,500'], ['b2', RUPEE + '1,500 – ' + RUPEE + '3,000'], ['b3', RUPEE + '3,000+']] }
  ];

  // ---- visitor + attribution (first landing of the session wins) ----
  var vid = LS.get('ahlc_vid') || (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
  LS.set('ahlc_vid', vid);
  if (!SS.get('ahlc_utm')) {
    SS.set('ahlc_utm', JSON.stringify({
      source: qs.get('utm_source') || (qs.get('gclid') ? 'google' : qs.get('fbclid') ? 'meta' : ''),
      medium: qs.get('utm_medium') || (qs.get('gclid') || qs.get('fbclid') ? 'paid' : ''),
      campaign: qs.get('utm_campaign') || '',
      referrer: document.referrer || ''
    }));
  }
  var utm = JSON.parse(SS.get('ahlc_utm') || '{}');
  var paid = /paid|cpc|ppc/i.test(utm.medium || '') || /google|meta|facebook|ig/i.test(utm.source || '') && /paid|cpc/i.test(utm.medium || '');

  var known = C.customer || LS.get('ahlc_known') === '1';
  var resting = Number(LS.get('ahlc_rest_until') || 0) > Date.now();
  var shownThisSession = SS.get('ahlc_shown') === '1';

  // ---- page classification ----
  var tpl = P.template;
  var isBonsaiCollection = tpl === 'collection' && /bonsai/.test(P.handle || '');
  var topic = detectTopic(((P.title || '') + ' ' + (P.tags || '') + ' ' + P.path).toLowerCase());

  // Saved-cart bar works independently of the popup budget.
  if (!known && C.cartBar !== false) initCartBar();
  if (known && !forced) return;

  var offer = pickOffer();
  if (!offer) return;
  if (forced) { setTimeout(function () { open(offer); }, 300); return; }
  if (buying()) return;
  if (shownThisSession || resting) { maybePill(offer); return; }
  arm(offer);

  // =====================================================================================
  function pickOffer() {
    if (mode === 'quiz' || isBonsaiCollection) return { kind: 'quiz', trigger: { time: paid ? 12 : 20, depth: 1.6 } };
    if (tpl === 'article') return { kind: 'guide', trigger: { time: 45, scrollPct: 0.5 } };
    if (tpl === 'product') {
      // Sold-out pages still get paid traffic — offer the credit on a similar tree, sooner.
      if (P.available === false) return { kind: 'credit', soldOut: true, trigger: { time: paid ? 8 : 20, exit: true } };
      return { kind: 'credit', trigger: { time: paid ? 15 : 40, exit: true } };
    }
    if (tpl === 'collection' || tpl === 'index' || tpl === 'search' || tpl === 'page' || tpl === 'list-collections' || tpl === 'blog')
      return { kind: 'credit', trigger: { time: paid ? 15 : 40, exit: true } };
    return null;
  }

  function arm(offer) {
    var t = offer.trigger, fired = false;
    function fire() {
      if (fired) return;
      if (buying()) { fired = true; cleanup(); return; }
      if (checkoutOpen()) { clearTimeout(timer); timer = setTimeout(fire, 5000); return; } // wait until it closes
      fired = true; cleanup(); open(offer);
    }
    var timer = setTimeout(fire, t.time * 1000);
    var lastY = window.scrollY, lastT = Date.now(), maxY = 0;
    function onScroll() {
      var y = window.scrollY, now = Date.now(), h = document.documentElement.scrollHeight - innerHeight;
      maxY = Math.max(maxY, y);
      if (t.scrollPct && h > 0 && y / h >= t.scrollPct) return fire();
      if (t.depth && y >= innerHeight * t.depth) return fire();
      // Mobile "exit intent": a fast flick back up after reading a good part of the page.
      if (t.exit && maxY > innerHeight * 1.2 && lastY - y > 0) {
        var v = (lastY - y) / Math.max(now - lastT, 1);
        if (v > 2.2 && lastY - y > 120) return fire();
      }
      lastY = y; lastT = now;
    }
    function onLeave(e) { if (t.exit && e.clientY <= 0 && !e.relatedTarget) fire(); }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onLeave);
    function cleanup() { clearTimeout(timer); window.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onLeave); }
  }

  // ---- the sheet ----------------------------------------------------------------------
  var root;
  function open(offer) {
    if (document.querySelector('.ahlc-sheet')) return;
    SS.set('ahlc_shown', '1');
    removePill();
    root = el('div', 'ahlc-overlay');
    var sheet = el('div', 'ahlc-sheet');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Abana Homes offer');
    var close = el('button', 'ahlc-close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.onclick = function () { dismiss(offer); };
    root.addEventListener('click', function (e) { if (e.target === root) dismiss(offer); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { dismiss(offer); document.removeEventListener('keydown', esc); } });
    sheet.appendChild(close);
    var body = el('div', 'ahlc-body');
    sheet.appendChild(body);
    root.appendChild(sheet);
    document.body.appendChild(root);
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    if (offer.kind === 'quiz') renderQuiz(body, offer); else renderForm(body, offer);
    track('ahlc_open', offer.kind);
  }

  // Checkout started under an open popup: get out of the way without counting it as a dismissal.
  function closeQuiet() {
    if (!root) return;
    var r = root; root = null;
    r.remove();
  }

  function dismiss(offer) {
    if (!root) return;
    LS.set('ahlc_rest_until', String(Date.now() + 7 * 864e5));
    root.classList.remove('is-open');
    var r = root; root = null;
    setTimeout(function () { r.remove(); }, 250);
    track('ahlc_dismiss', offer.kind);
    maybePill(offer);
  }

  function copyFor(offer) {
    if (offer.kind === 'guide') {
      var plant = topic.label;
      return {
        eyebrow: 'Free on WhatsApp',
        title: plant ? 'Your free ' + plant + ' care guide' : 'Your free plant care guide',
        sub: 'Plus ' + CREDIT + ' off your first plant order. Send us a photo anytime — our gardeners reply on WhatsApp.',
        bullets: ['Watering, light & soil in one page', CREDIT + ' credit, valid ' + C.validDays + ' days on orders above ' + MIN],
        cta: 'Send me the guide', img: P.image
      };
    }
    var onProduct = tpl === 'product';
    if (offer.soldOut) return {
      eyebrow: 'This one is sold out',
      title: 'Get ' + CREDIT + ' off a similar bonsai',
      sub: 'Tell us your WhatsApp — we’ll send your code and the closest trees we have in stock today.',
      bullets: ['Valid ' + C.validDays + ' days on orders above ' + MIN, 'Real photos of the plant before dispatch — just ask'],
      cta: 'Send my ' + CREDIT + ' credit', img: P.image
    };
    return {
      eyebrow: 'Before you go',
      title: 'Get ' + CREDIT + ' off ' + (onProduct ? 'this bonsai' : 'your first bonsai'),
      sub: 'We’ll send your personal code on WhatsApp — valid ' + C.validDays + ' days on orders above ' + MIN + '.',
      bullets: ['Real photos of the plant before dispatch — just ask', 'Free bonsai care guide included'],
      cta: 'Send my ' + CREDIT + ' credit', img: P.image
    };
  }

  function renderForm(body, offer, extra) {
    var k = copyFor(offer);
    body.innerHTML = '';
    if (k.img) { var im = el('img', 'ahlc-img'); im.src = k.img; im.alt = ''; im.loading = 'lazy'; body.appendChild(im); }
    body.appendChild(el('p', 'ahlc-eyebrow', k.eyebrow));
    body.appendChild(el('h2', 'ahlc-title', k.title));
    body.appendChild(el('p', 'ahlc-sub', k.sub));
    var ul = el('ul', 'ahlc-bullets');
    k.bullets.forEach(function (b) { ul.appendChild(el('li', '', b)); });
    body.appendChild(ul);
    body.appendChild(phoneForm(k.cta, function (phone, done) {
      submit({ kind: offer.kind === 'guide' ? 'guide' : offer.kind, phone: phone, quiz: extra && extra.quiz }, function (ok, msg, wa) {
        done(ok, msg);
        if (ok) success(body, msg, extra && extra.result, wa);
      });
    }));
  }

  function phoneForm(cta, onSubmit) {
    var f = el('form', 'ahlc-form');
    f.noValidate = true;
    var row = el('div', 'ahlc-phone');
    row.appendChild(el('span', 'ahlc-cc', '+91'));
    var inp = el('input');
    inp.type = 'tel'; inp.inputMode = 'numeric'; inp.autocomplete = 'tel-national'; inp.maxLength = 14;
    inp.placeholder = 'WhatsApp number'; inp.setAttribute('aria-label', 'WhatsApp number');
    row.appendChild(inp);
    f.appendChild(row);
    var hp = el('input', 'ahlc-hp'); hp.name = 'company'; hp.tabIndex = -1; hp.autocomplete = 'off'; hp.setAttribute('aria-hidden', 'true');
    f.appendChild(hp);
    var btn = el('button', 'ahlc-btn', cta); btn.type = 'submit';
    f.appendChild(btn);
    var err = el('p', 'ahlc-err'); err.setAttribute('role', 'alert');
    f.appendChild(err);
    f.appendChild(el('p', 'ahlc-consent', 'By tapping, you agree to get offers & plant-care tips from Abana Homes on WhatsApp. Reply STOP anytime.'));
    f.onsubmit = function (e) {
      e.preventDefault();
      if (hp.value) return;
      var d = inp.value.replace(/\D/g, '').replace(/^(91|0)(?=\d{10}$)/, '');
      if (!/^[6-9]\d{9}$/.test(d)) { err.textContent = 'Please enter a valid 10-digit WhatsApp number'; inp.focus(); return; }
      err.textContent = ''; btn.disabled = true; btn.textContent = 'Sending…';
      onSubmit(d, function (ok, msg) {
        if (!ok) { btn.disabled = false; btn.textContent = cta; err.textContent = msg; }
      });
    };
    setTimeout(function () { if (matchMedia('(pointer:fine)').matches) inp.focus(); }, 350);
    return f;
  }

  // The visitor sending the prefilled "Ref LC-…" message is what reliably delivers the code (free reply inside
  // the 24h window); a marketing template alone is dropped by Meta for most numbers.
  function waButton(wa, label) {
    var a = el('a', 'ahlc-btn ahlc-wa', label);
    a.href = wa; a.target = '_blank'; a.rel = 'noopener';
    a.onclick = function () { track('ahlc_wa_open', tpl); };
    return a;
  }

  function success(body, msg, result, wa) {
    LS.set('ahlc_known', '1');
    body.innerHTML = '';
    body.appendChild(el('div', 'ahlc-tick', '✓'));
    body.appendChild(el('h2', 'ahlc-title', wa ? 'One last tap' : 'Sent to your WhatsApp'));
    body.appendChild(el('p', 'ahlc-sub', msg));
    if (wa) body.appendChild(waButton(wa, 'Open WhatsApp & get it now'));
    if (result) body.appendChild(resultCard(result));
    var b = el('button', 'ahlc-btn ahlc-btn--ghost', result ? 'Keep browsing' : 'Continue shopping');
    b.type = 'button';
    b.onclick = function () { if (root) { root.classList.remove('is-open'); var r = root; root = null; setTimeout(function () { r.remove(); }, 250); } };
    body.appendChild(b);
    track('ahlc_lead', 'ok');
  }

  // ---- quiz -----------------------------------------------------------------------------
  function quizResult(ans) {
    var spot = ans[0], first = ans[1] === 'first', r;
    if (spot === 'low') r = { h: 'ficus-bonsai-plants', name: 'Ficus bonsai', why: 'Handles indoor light and missed waterings — the easiest bonsai to keep happy.' };
    else if (spot === 'window') r = first
      ? { h: 'ficus-bonsai-plants', name: 'Ficus bonsai', why: 'Loves a bright window and forgives beginner mistakes.' }
      : { h: 'carmona-bonsai', name: 'Carmona (Fukien tea) bonsai', why: 'Tiny white flowers through the year in bright indoor light.' };
    else r = first
      ? { h: 'chinese-elm-bonsai-plants', name: 'Chinese Elm bonsai', why: 'Hardy on balconies, takes Indian summers well.' }
      : { h: 'outdoor-bonsai-tree', name: 'Outdoor bonsai', why: 'Juniper, elm and more for sun-lit balconies and gardens.' };
    var f = { b1: 'filter.v.price.lte=1500', b2: 'filter.v.price.gte=1500&filter.v.price.lte=3000', b3: 'filter.v.price.gte=3000' }[ans[2]];
    r.url = '/collections/' + r.h + '?' + f + '&utm_source=site&utm_medium=quiz';
    return r;
  }
  function resultCard(r) {
    var a = el('a', 'ahlc-result');
    a.href = r.url;
    a.appendChild(el('span', 'ahlc-result__k', 'Your match'));
    a.appendChild(el('strong', 'ahlc-result__n', r.name));
    a.appendChild(el('span', 'ahlc-result__w', r.why));
    a.appendChild(el('span', 'ahlc-result__go', 'See my matches →'));
    return a;
  }
  function renderQuiz(body, offer) {
    var ans = [];
    function step(i) {
      body.innerHTML = '';
      if (i === 0) body.appendChild(el('p', 'ahlc-eyebrow', 'Find your bonsai in 3 taps'));
      var dots = el('div', 'ahlc-dots');
      for (var d = 0; d < QUIZ.length + 1; d++) dots.appendChild(el('span', d <= i ? 'on' : ''));
      body.appendChild(dots);
      if (i < QUIZ.length) {
        body.appendChild(el('h2', 'ahlc-title', QUIZ[i].q));
        var g = el('div', 'ahlc-opts');
        QUIZ[i].a.forEach(function (o) {
          var b = el('button', 'ahlc-opt', o[1]); b.type = 'button';
          b.onclick = function () { ans[i] = o[0]; step(i + 1); };
          g.appendChild(b);
        });
        body.appendChild(g);
        return;
      }
      var r = quizResult(ans);
      body.appendChild(el('h2', 'ahlc-title', 'We found your match 🌿'));
      body.appendChild(el('p', 'ahlc-sub', 'Get it on WhatsApp with ' + CREDIT + ' off your first order (above ' + MIN + ', valid ' + C.validDays + ' days).'));
      body.appendChild(phoneForm('Show my match + ' + CREDIT + ' credit', function (phone, done) {
        submit({ kind: 'quiz', phone: phone, quiz: { spot: ans[0], level: ans[1], budget: ans[2], match: r.h } }, function (ok, msg, wa) {
          done(ok, msg);
          if (ok) success(body, msg, r, wa);
        });
      }));
      var skip = el('button', 'ahlc-skip', 'Just show me the match');
      skip.type = 'button';
      skip.onclick = function () { track('ahlc_quiz_skip', r.h); location.href = r.url; };
      body.appendChild(skip);
    }
    step(0);
  }

  // ---- pill -----------------------------------------------------------------------------
  function maybePill(offer) {
    if (known || LS.get('ahlc_pill_off') === String(new Date().toDateString())) return;
    if (document.querySelector('.ahlc-pill')) return;
    var p = el('div', 'ahlc-pill');
    var b = el('button', 'ahlc-pill__btn', '🎁 ' + CREDIT + ' credit');
    b.type = 'button';
    b.onclick = function () { open(offer.kind === 'quiz' ? offer : { kind: tpl === 'article' ? 'guide' : 'credit' }); };
    var x = el('button', 'ahlc-pill__x', '×');
    x.type = 'button'; x.setAttribute('aria-label', 'Hide offer');
    x.onclick = function () { LS.set('ahlc_pill_off', new Date().toDateString()); removePill(); };
    p.appendChild(b); p.appendChild(x);
    document.body.appendChild(p);
  }
  function removePill() { var p = document.querySelector('.ahlc-pill'); if (p) p.remove(); }

  // ---- saved-cart bar (cart drawer + /cart) ---------------------------------------------
  function initCartBar() {
    var busy = false;
    var place = function () {
      if (busy || LS.get('ahlc_known') === '1') return;
      // Dawn keeps <cart-drawer> in the DOM on every page — only act while it is open, or on /cart.
      var sel = tpl === 'cart' ? '.cart__footer .cart__ctas' : 'cart-drawer.active .drawer__footer .cart__ctas';
      var ctas = document.querySelector(sel);
      if (!ctas || ctas.parentNode.querySelector('.ahlc-cartbar')) return;
      busy = true;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        busy = false;
        if (!cart.item_count || !ctas.isConnected || ctas.parentNode.querySelector('.ahlc-cartbar')) return;
        ctas.parentNode.insertBefore(cartBar(cart), ctas);
      }).catch(function () { busy = false; });
    };
    place();
    var mo = new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(place, 250); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  function cartBar(cart) {
    var w = el('div', 'ahlc-cartbar');
    var saved = LS.get('ahlc_cart_saved') === cart.token;
    if (saved) { w.appendChild(el('p', 'ahlc-cartbar__t', '✓ Cart saved to your WhatsApp')); return w; }
    var open = el('button', 'ahlc-cartbar__open', '📲 Not ready yet? Save this cart to WhatsApp');
    open.type = 'button';
    w.appendChild(open);
    open.onclick = function () {
      w.innerHTML = '';
      w.appendChild(el('p', 'ahlc-cartbar__t', 'We’ll send your cart link to WhatsApp so you can finish anytime.'));
      w.appendChild(phoneForm('Save my cart', function (phone, done) {
        var items = cart.items.map(function (i) { return i.product_title + (i.quantity > 1 ? ' x' + i.quantity : ''); }).join(', ');
        var img = cart.items[0] && cart.items[0].image ? cart.items[0].image.replace(/^\/\//, 'https://') : '';
        submit({ kind: 'cart', phone: phone, cart: { token: cart.token, value: cart.total_price / 100, items: items, image: img } }, function (ok, msg, wa) {
          done(ok, msg);
          if (ok) {
            LS.set('ahlc_known', '1'); LS.set('ahlc_cart_saved', cart.token);
            w.innerHTML = ''; w.appendChild(el('p', 'ahlc-cartbar__t', '✓ ' + msg));
            if (wa) w.appendChild(waButton(wa, 'Open WhatsApp & save it'));
            track('ahlc_lead', 'cart');
          }
        });
      }));
    };
    return w;
  }

  // ---- network ---------------------------------------------------------------------------
  function submit(data, cb) {
    var payload = {
      phone: data.phone, kind: data.kind, consent_text: CONSENT, quiz: data.quiz || undefined, cart: data.cart || undefined,
      page: { type: tpl, path: P.path, title: P.title, topic: topic.key || P.handle || '', image: P.image || '' },
      utm: { source: utm.source, medium: utm.medium, campaign: utm.campaign }, referrer: utm.referrer, visitor_id: vid
    };
    fetch(C.api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (j) {
        var wa = j.ok && /^https:\/\/wa\.me\//.test(j.wa || '') ? j.wa : null;
        cb(!!j.ok, j.ok ? (j.message || 'Check your WhatsApp.') : (j.error || 'Something went wrong — please try again.'), wa);
      })
      .catch(function () { cb(false, 'Network problem — please try again.'); });
  }

  function track(ev, label) {
    try { if (window.gtag) window.gtag('event', ev, { event_label: label, page_type: tpl }); } catch (e) {}
    try { if (window.fbq && ev === 'ahlc_lead') window.fbq('track', 'Lead', { content_category: label }); } catch (e) {}
  }

  function detectTopic(s) {
    var T = [['bonsai', 'bonsai'], ['areca', 'areca palm'], ['snake plant', 'snake plant'], ['peace lily', 'peace lily'],
      ['money plant', 'money plant'], ['pothos', 'money plant'], ['hibiscus', 'hibiscus'], ['champa', 'champa'], ['jade', 'jade plant'],
      ['parlor palm', 'palm'], ['palm', 'palm'], ['tulsi', 'tulsi'], ['rose', 'rose'], ['fertili', 'plant feeding'], ['npk', 'plant feeding']];
    for (var i = 0; i < T.length; i++) if (s.indexOf(T[i][0]) !== -1) return { key: T[i][1].replace(/ /g, '-'), label: T[i][1] };
    return { key: '', label: '' };
  }

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function safeStore(s) {
    return {
      get: function (k) { try { return s.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { s.setItem(k, v); } catch (e) {} },
      del: function (k) { try { s.removeItem(k); } catch (e) {} }
    };
  }
})();
